export default "__VITE_ASSET__D9vVO4zg__"